<template>
    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <page-title :title="$t('columns.title')"></page-title>
    </div>

    <jet-form-section @submitted="updateColumns()">
        <template #form>
            <form-card
                :title="$t('columns.title')"
                :description="$t('columns.projectDescription')"
            >
                <div class="col-span-6">
                    <column-visibility-matrix
                        v-model:internal="form.updateColumns.internal"
                        v-model:buyer="form.updateColumns.buyer"
                        :locked-columns="lockedColumns ?? []"
                        :is-budget-based="isBudgetBased ?? false"
                    />
                </div>
            </form-card>
        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">
                <button
                    @click="cancel"
                    type="button"
                    class="inline-block uppercase font-semibold text-xs tracking-widest"
                >
                    {{ $t("actions.cancel") }}
                </button>

                <primary-button
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                    class="ml-3"
                >
                    {{ $t("actions.save") }}
                </primary-button>
            </div>
        </template>
    </jet-form-section>
</template>

<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import FormCard from "@/Shared/Components/FormCard";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm } from "@inertiajs/inertia-vue3";
import ColumnVisibilityMatrix from "@/Shared/Components/Projects/ColumnVisibilityMatrix";

// Thema 1 (Spec docs/superpowers/specs/2026-08-04-welle2-spalten-sichtbarkeit-design.md):
// Projekt-Einstieg der Spalten-Sichtbarkeit — setzt den Standard, den alle
// Wohnungen ohne eigenen Override übernehmen (`Project::visibleColumns()`).
// Anders als die Wohnungs-Variante gibt es hier keine "Projekt-Standard
// verwenden"-Checkbox — das Projekt IST der Standard.
export default defineComponent({
    // Auftrag 2026-08-16, Entscheid 14: `lockedColumns` nennt die Spalten, die
    // diese Agentur nicht ausblenden darf — ohne den Grund zu nennen
    // (Entscheid 15).
    props: ["project", "visibility", "lockedColumns", "isBudgetBased"],
    inheritAttrs: false,
    emits: ["closeModal"],
    layout: MainLayout,
    components: {
        PageTitle,
        FormCard,
        PrimaryButton,
        JetFormSection,
        ColumnVisibilityMatrix,
    },
    data() {
        return {
            form: useForm({
                updateColumns: {
                    internal: [...this.visibility.internal],
                    buyer: [...this.visibility.buyer],
                },
            }),
        };
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        updateColumns() {
            this.form.post(
                this.route("advisors.projects.updateColumns", {
                    project: this.project.uuid,
                }),
                {
                    preserveScroll: true,
                    onSuccess: () =>
                        this.$notify({
                            group: "success",
                            title: "actions.success",
                            text: "projects.updated",
                        }),
                }
            );
        },
    },
});
</script>

<style scoped></style>
